export enum WizardStep {
  WELCOME = 0,
  PORTRAIT_PHOTO = 1,
  FACETEC_VERIFICATION = 2,
  APPLICATION_FORM = 3,
  CONFIRMATION = 4
}

export interface PortraitData {
  file: File | null;
  dataUrl: string;
  width: number;
  height: number;
}

export interface ApplicationFormData {
  familyNameHebrew: string;
  givenNameHebrew: string;
  email: string;
  previousLicenseNumber: string;
  licenseExpirationDate: string;
  paymentCode: string;
  paymentDate: string;
}

export class WizardState {
  public currentStep: WizardStep = WizardStep.WELCOME;
  public portrait: PortraitData | null = null;
  public faceTecCompleted: boolean = false;
  public formData: ApplicationFormData = {
    familyNameHebrew: "",
    givenNameHebrew: "",
    email: "",
    previousLicenseNumber: "",
    licenseExpirationDate: "",
    paymentCode: "",
    paymentDate: ""
  };

  public reset(): void {
    this.currentStep = WizardStep.WELCOME;
    this.portrait = null;
    this.faceTecCompleted = false;
    this.formData = {
      familyNameHebrew: "",
      givenNameHebrew: "",
      email: "",
      previousLicenseNumber: "",
      licenseExpirationDate: "",
      paymentCode: "",
      paymentDate: ""
    };
  }
}
